/**
 * Generated by @openapi-codegen
 *
 * @version 0.0.0
 */
import * as reactQuery from 'react-query';
import { useOpenapiContext, OpenapiContext } from 'openapi/client/OpenapiContext';
import type * as Fetcher from 'openapi/client/OpenapiFetcher';
import { openapiFetch } from 'openapi/client/OpenapiFetcher';
import type * as Schemas from 'openapi/client/OpenapiSchemas';

export type ApiActionsDescriptionAudiosListPathParams = {
  /**
   * @format uuid
   */
  id: string;
};

export type ApiActionsDescriptionAudiosListError = Fetcher.ErrorWrapper<undefined>;

export type ApiActionsDescriptionAudiosListResponse = Schemas.SubtitleAudio[];

export type ApiActionsDescriptionAudiosListVariables = {
  pathParams: ApiActionsDescriptionAudiosListPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchApiActionsDescriptionAudiosList = (
  variables: ApiActionsDescriptionAudiosListVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    ApiActionsDescriptionAudiosListResponse,
    ApiActionsDescriptionAudiosListError,
    undefined,
    {},
    {},
    ApiActionsDescriptionAudiosListPathParams
  >({ url: '/api/actions/{id}/description_audios/', method: 'get', ...variables, signal });

export const useApiActionsDescriptionAudiosList = <
  TData = ApiActionsDescriptionAudiosListResponse,
>(
  variables: ApiActionsDescriptionAudiosListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ApiActionsDescriptionAudiosListResponse,
      ApiActionsDescriptionAudiosListError,
      TData
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useOpenapiContext(options);
  return reactQuery.useQuery<
    ApiActionsDescriptionAudiosListResponse,
    ApiActionsDescriptionAudiosListError,
    TData
  >({
    queryKey: queryKeyFn({
      path: '/api/actions/{id}/description_audios/',
      operationId: 'apiActionsDescriptionAudiosList',
      variables,
    }),
    queryFn: ({ signal }) =>
      fetchApiActionsDescriptionAudiosList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation = {
  path: '/api/actions/{id}/description_audios/';
  operationId: 'apiActionsDescriptionAudiosList';
  variables: ApiActionsDescriptionAudiosListVariables;
};
